import TransporteCard from "./TransporteCard";
import { useTranslations } from "next-intl";

type Props = {
  actual: "taxi" | "alquiler" | "metrobus" | "metro";
};

const NAVY = "#102542";

export default function OtrasOpciones({ actual }: Props) {
  const t = useTranslations("otrasOpciones");

  const opciones = {
    taxi: {
      titulo: "Taxi",
      eyebrow: t("labelTaxi"),
      descripcion: t("taxi"),
      imagen: "https://galeria.tocumenaero.com/gallery/transporte/taxi1.JPG",
      link: "/transporte/taxi",
    },
    alquiler: {
      titulo: t("alquilerTitle"),
      eyebrow: t("labelAlquiler"),
      descripcion: t("alquiler"),
      imagen:
        "https://galeria.tocumenaero.com/gallery/api/%C3%81rea%20de%20Arrendadoras/321A8752.jpg",
      link: "/transporte/alquiler-autos",
    },
    metrobus: {
      titulo: "MetroBus",
      eyebrow: t("labelMetrobus"),
      descripcion: t("metrobus"),
      imagen:
        "https://galeria.tocumenaero.com/gallery/api/MetroBus/321A8648.jpg",
      link: "/transporte/metrobus",
    },
    metro: {
      titulo: "Metro",
      eyebrow: t("labelMetro"),
      descripcion: t("metro"),
      imagen:
        "https://galeria.tocumenaero.com/gallery/api/Metro%20de%20Panam%C3%A1/9M1A2785.jpg",
      link: "/transporte/metro",
    },
  };

  const otrasOpciones = Object.entries(opciones).filter(
    ([key]) => key !== actual,
  );

  return (
    <section className="">
      <div className="pt-12 pb-24">
        <div className="max-w-3xl mb-14">
          <span
            className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold mb-4"
            style={{ color: NAVY }}
          >
            <span className="w-8 h-px" style={{ backgroundColor: NAVY }} />
            {t("eyebrow")}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 tracking-tight mb-4">
            {t("title")}
          </h2>
          <p className="text-gray-600 text-base md:text-lg leading-relaxed">
            {t("subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-gray-200 rounded-2xl overflow-hidden border border-gray-200">
          {otrasOpciones.map(([key, data], idx) => (
            <TransporteCard
              key={key}
              index={idx + 1}
              eyebrow={data.eyebrow}
              titulo={data.titulo}
              descripcion={data.descripcion}
              imagen={data.imagen}
              link={data.link}
              buttonLabel={t("buttonLabel")}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
